import { MenuItemEntity } from "../../../../entities/UIEntities/MenuItem";
import { CLIENT_ROUTES, MENU_ITEMS } from "../../../../enums/Enums";
import Icons from "../../../../resources/icons/Icons";
import { getGreetingValue } from "../../../../utils/CommonUtils";
import { handleLogout } from "../../../../utils/MenuUtils";
import CustomMenu from "../../Menus/CustomMenu/CustomMenu";
import RoundImage from "../RoundImage";
import classes from "./HeaderAvatarInfo.module.css";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const UserInfo = (props) => {
  let navigate = useNavigate();
  const greetingValue = getGreetingValue();
  const gmtUser = useSelector((state) => state.user.gmtUser?.utronUser);
  const menuItems = [
    new MenuItemEntity(
      MENU_ITEMS.MY_PROFILE,
      () => {
        return navigate(CLIENT_ROUTES.EDIT_PROFILE);
      },
      true,
      Icons.MY_PROFILE,
      false,
      props
    ),
    new MenuItemEntity(
      MENU_ITEMS.LEGAL,
      () => {
        return navigate(CLIENT_ROUTES.LEGAL);
      },
      true,
      Icons.LEGAL,
      false,
      props
    ),
    new MenuItemEntity(
      MENU_ITEMS.LOGOUT,
      handleLogout,
      false,
      Icons.LOGOUT,
      false,
      props
    ),
  ];
  return (
    <div className={classes.userInfo}>
      <RoundImage image={gmtUser?.image}></RoundImage>
      <div className={classes.nameContainer}>
        <span>{greetingValue}</span>
        <div className={classes.name}>
          <span>{`${gmtUser?.firstName} ${gmtUser?.lastName}`}</span>
          <CustomMenu isHeaderMode={true} menuItems={menuItems}></CustomMenu>
        </div>
      </div>
    </div>
  );
};

export default UserInfo;
